module.exports = __webpack_public_path__ + "img/iconLogoName.c53d3557.png";